'use client';

export function AuthBackground() {
  return (
    <svg className="pointer-events-none fixed inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg">
      <line x1="0" y1="70%" x2="35%" y2="30%" stroke="#d3e2fd" strokeWidth="1" />
      <line x1="35%" y1="30%" x2="60%" y2="55%" stroke="#d3e2fd" strokeWidth="1" />
      <line x1="75%" y1="10%" x2="110%" y2="60%" stroke="#d3e2fd" strokeWidth="1" />
    </svg>
  );
}
